import React from "react";
import {
  Container,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Box,
  Typography,
  TextField,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { connect } from "react-redux";
import * as premiumApi from "../../api/premiumApi";
import * as dataApi from "../../api/dataApi";
import ScrollToTopBtn from "../common/ScrollToTop";
import { withRouter } from "../common/WithRouter";
import SearchIcon from "@mui/icons-material/Search";

class PremiumListUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      membershiptype: props.type,
      premiums: [],
      premiumsDetails: [],
      year: "",
      years: [],
      pageSize: 50,
      searchQuery: "",
    };
  }

  async componentDidMount() {
    await this.fetchData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.type !== this.props.type) {
      this.setState({ membershiptype: this.props.type }, async () => {
        await this.fetchData();
      });
    }
  }

  fetchData = async () => {
    try {
      this.getYears();
      const user = this.props.signedinuser;
      if (user) {
        this.setState({ user });
        this.getPremiums(user.companyId);
      }
    } catch (error) {
      console.log("Error in fetchData", error);
    }
  };

  getPremiums = async (companyId) => {

    const { membershiptype, year } = this.state;
    const premiums = await premiumApi.getPremiums(membershiptype, year, companyId);
    console.log(premiums)

    if (!premiums) return this.setState({ premiums: [], premiumsDetails: [] });

    if (membershiptype === "TFF") {
      const aggregated = this.aggregateTffPremiumsByYear(premiums);
      aggregated.sort((a, b) => b.prizeYear - a.prizeYear);
      this.setState({ premiums: aggregated, premiumsDetails: premiums });
    } else {
      premiums.sort((a, b) => b.prizeYear - a.prizeYear);
      this.setState({ premiums, premiumsDetails: premiums });
    }
  };

  aggregateTffPremiumsByYear = (premiums) => {
    const grouped = premiums.reduce((acc, premium) => {
      const key = premium.prizeYear;
      if (!acc[key]) {
        acc[key] = {
          prizeYear: key,
          reportedByCompanyName: premium.reportedByCompanyName,
          amount: 0,
          prizeId: `${key}`,
        };
      }
      acc[key].amount += Number(premium.amount || 0);
      return acc;
    }, {});
    return Object.values(grouped).sort((a, b) => b.prizeYear - a.prizeYear);
  };


  getYears = async () => {
    const years = await dataApi.getYears(this.state.membershiptype);
    if (years) {
      this.setState({ years: years.sort((a, b) => b - a) });
    } else {
      this.setState({ years: [] });
    }
  };

  handleChange = async (e) => {
    const name = e.target.name;
    await this.setState({ [name]: e.target.value });
    this.getPremiums(this.state.user.companyId);
  };

  handleSearchChange = (e) => {
    this.setState({ searchQuery: e.target.value });
  };

  render() {
    const { membershiptype, years, year, user, premiums } = this.state;

    const columns = [
      {
        field: "actions",
        headerName: "",
        flex: 1,
        sortable: false,
        renderCell: (params) => (
          <Button
            variant="outlined"
            size="medium"
            color="primary"
            onClick={() => {
              this.props.navigate(`/premiumdetail${membershiptype}/${params.row.prizeYear}`);
            }}
          >
            <ArrowForwardIosIcon sx={{ mr: 1 }} />
            Vis Mer
          </Button>
        ),
      },
      {
        field: "prizeYear",
        headerName: "År",
        flex: 1,
        sortable: true,
      },
      {
        field: "reportedByCompanyName",
        headerName: "Navn",
        flex: 2,
        sortable: true,
        cellClassName: "wrap-text",
      },
      {
        field: "amount",
        headerName: "Beløp i NOK",
        maxWidth: 250,
        sortable: true,
        align: "right",
        headerAlign: "right",
        valueFormatter: (params) => {
          if ((!params && params !== 0) || params < 0) {
            return "Ukjent";
          }
          return Number(params).toLocaleString("de-DE");
        },

      },
    ];

    return (
      <React.Fragment>
        <Container maxWidth={false} sx={{ width: "100vw", overflowX: "hidden" }}>
          <main style={{ width: "100%", paddingTop: 80 }}>
            <Paper
              style={{
                padding: "20px",
                width: "100%",
                minWidth: 400,
                maxWidth: 1400,
                overflowX: "auto",
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
              }}>
              {/* Title & Search Bar */}
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6" sx={{ fontWeight: "normal", fontSize: "1.3rem" }}>
                  PREMIEOVERSIKT
                </Typography>
                <TextField
                  variant="standard"
                  size="small"
                  placeholder="Søk"
                  InputProps={{
                    startAdornment: <SearchIcon sx={{ mr: 1 }} />,
                    disableUnderline: false,
                  }}
                  onChange={(e) => this.setState({ searchQuery: e.target.value })}
                  sx={{ width: 250 }}
                />
              </Box>

              {/* Filter Controls */}
              <Box display="flex" gap={6} flexWrap="wrap" mb={2} justifyContent="flex-start" alignItems="center" >
                <FormControl sx={{ flex: 1, minWidth: 80, maxWidth: 150 }}>
                  <TextField
                    label="Organisasjon"
                    variant="standard"
                    value={membershiptype}
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </FormControl>

                <FormControl sx={{ flex: 1, minWidth: 200, maxWidth: 300 }}>
                  <TextField
                    label="Bedrift"
                    variant="standard"
                    value={user.companyName || ""}
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </FormControl>

                <FormControl sx={{ flex: 1, minWidth: 100, maxWidth: 100 }}>
                  <InputLabel>År</InputLabel>
                  <Select
                    name="year"
                    value={year || ""}
                    onChange={this.handleChange}
                    variant="standard"
                  >
                    <MenuItem value="">Alle</MenuItem>
                    {years.map((y, index) => (
                      <MenuItem key={index} value={y}>
                        {y}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>

              {/* Data Grid Table */}
              <DataGrid
                style={{
                  borderStyle: "none",
                  tableLayout: "fixed",
                  width: "100%",
                  maxWidth: "100vw",
                }}
                rows={
                  this.state.searchQuery
                    ? premiums.filter((premium) =>
                      Object.values(premium).some(
                        (value) =>
                          value &&
                          value.toString().toLowerCase().includes(this.state.searchQuery.toLowerCase())
                      )
                    )
                    : premiums
                }
                columns={columns.map((col) => ({
                  ...col,
                  minWidth: col.field === "prizeYear" ? 80 : 150,
                  maxWidth: 400,
                  resizable: false
                }))}
                disableColumnReorder={false}
                pageSizeOptions={[10, 50, 100]}
                pagination
                autoHeight
                disableSelectionOnClick
                getRowId={(row) => row.prizeId}
                sx={{
                  "& .MuiDataGrid-cell:focus": {
                    outline: "none !important",
                  },
                  "& .MuiDataGrid-columnHeader:focus": {
                    outline: "none !important",
                  },
                  "& .wrap-text": {
                    whiteSpace: "normal !important",
                    wordBreak: "break-word",
                    lineHeight: "1.2",
                    display: "flex",
                    alignItems: "center",
                  },
                }}
              />
            </Paper>

          </main>
        </Container>
        <ScrollToTopBtn />
      </React.Fragment>
    );
  }
}


function mapStateToProps(state) {
  const signedinuser = state.signedinuserobject
    ? state.signedinuserobject.signedInUser
    : sessionStorage.getItem("token")
      ? JSON.parse(sessionStorage.getItem("token"))
      : [];

  return { signedinuser };
}

export default connect(mapStateToProps)(withRouter(PremiumListUser));
